'use client'

import dynamic from 'next/dynamic'
import { useState } from 'react'
import { Box, Chip, Container, Grid } from '@mui/material'

// Types
import type { CustomersDirectoryProps } from '@/types/components/organisms/customers'

// Components
const RevealAtom = dynamic(() => import('@/components/atoms/animation/reveal'))
const SectionHeadingMolecule = dynamic(() => import('@/components/molecules/solution/section-heading'))
const BrandCardMolecule = dynamic(() => import('@/components/molecules/customers/brand-card'))

// Type filter stays hidden while the list is short
const SHOW_FILTERS = false

// Every business using RateUp, filterable by type
const CustomersDirectoryOrganism = (props: CustomersDirectoryProps) => {
	// Props
	const { lng, locale } = props

	// Variables
	const { items, directory } = locale.content.brands
	const types = Array.from(new Set(items.map(item => item.type)))
	const [type, setType] = useState<string>('')
	const shown = type ? items.filter(item => item.type === type) : items

	return (
		<Container maxWidth="lg" sx={{ py: { xs: 8, md: 12 } }}>
			<RevealAtom>
				<SectionHeadingMolecule title={directory.title} subtitle={directory.subtitle} />
			</RevealAtom>

			{SHOW_FILTERS && (
				<Box sx={{ mt: { xs: 4, md: 6 }, display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1 }}>
					{['', ...types].map(option => (
						<Chip
							key={option || 'all'}
							label={option || directory.all}
							clickable
							onClick={() => setType(option)}
							color={type === option ? 'primary' : 'default'}
							variant={type === option ? 'filled' : 'outlined'}
							sx={{ height: 38, px: 1, borderRadius: 2, fontSize: 14, fontWeight: 500, ...(type !== option && { bgcolor: 'common.white' }) }}
						/>
					))}
				</Box>
			)}

			<Grid container spacing={3} sx={{ mt: { xs: 4, md: 6 } }}>
				{shown.map(brand => (
					<Grid key={brand.slug} size={{ xs: 12, sm: 6, md: 4 }}>
						<BrandCardMolecule lng={lng} brand={brand} labels={directory} />
					</Grid>
				))}
			</Grid>
		</Container>
	)
}

export default CustomersDirectoryOrganism
